module.exports = __webpack_public_path__ + "static/Yuii.9b38f976.png";